import { createContext } from "react";

const RiskFinancingContext =
    createContext(null);

export default RiskFinancingContext;